import React from 'react'
import {Icon, Popup} from 'semantic-ui-react'
import styled from 'styled-components';
import { Box, Flex } from 'rebass'

import { formatMoney, calculateItemTotal } from "~/utils/money";

import QuantitySelector from '../quantity-selector'

const StaticQuantity = styled.div`
  font-weight: bold;
`;

const ItemName = styled.span`
  font-size: 16px;
  color: #222222;
  line-height: 24px;
`;

const RemoveIcon = styled(Icon)`
  color: #B4B4B4;
`;

const Total = styled.span`
  font-size: 14px;
  color: #222222;
  text-align: right;
  line-height: 24px;
  font-weight: bold;
`;

const TextRight = styled.div`
  text-align: right;
`;

export default class CartItem extends React.PureComponent {

  static defaultProps = {
    editable: true,
  };

  handleQuantityChange = (newQuantity) => {
    const { item, onQuantityChange } = this.props;

    onQuantityChange(item, newQuantity)
  };

  handleRemove = () => {
    const { item, onRemove } = this.props;

    onRemove(item);
  };

  render() {
    const { item, editable, compact } = this.props;

    const { quantity, name, price, locked_quantity } = item;
    const formattedPrice = formatMoney(price);
    const formattedTotal = formatMoney(calculateItemTotal(price, quantity));

    return(
      <Flex mx={ -4 } pt={ 5 } flexWrap='wrap' alignItems={ 'center' } compact={ compact }>
        <Box px={ 4 } py={ compact ? 1 : 3 } width={13/16}>
          <Popup position='right center' trigger={<ItemName>{ name }</ItemName>} content={ formattedPrice } inverted />
        </Box>
        <Box px={ 4 } py={ compact ? 1 : 3 } width={3/16}>
          <TextRight>
            { editable ? <RemoveIcon name='trash alternate' link onClick={ this.handleRemove}/> : null }
          </TextRight>
        </Box>
        <Box px={ 4 } py={ compact ? 1 : 3 } width={0.5}>
          { editable ?
            <QuantitySelector
              quantity={ quantity }
              onChange={ this.handleQuantityChange }
              disabled={ !!locked_quantity }
            />
            :
            <StaticQuantity>{quantity}x</StaticQuantity>
          }
        </Box>
        <Box px={ 4 } py={ compact ? 1 : 3 } width={0.5}>
          <TextRight>
            <Total>{ formattedTotal }</Total>
          </TextRight>
        </Box>
      </Flex>
    )
  }
}
